// extracted by mini-css-extract-plugin
export var container = "styles-module__container___sXX9E";
export var upperContainer = "styles-module__upperContainer___vbNpX";
export var upperContainerBgImage = "styles-module__upperContainerBgImage___b5P6b";
export var contentContainer = "styles-module__contentContainer___QQT90";
export var contentContainerBgImage = "styles-module__contentContainerBgImage___eSkpD";
export var logoProImage = "styles-module__logoProImage___GoXAm";
export var title = "styles-module__title___kHv40";
export var text = "styles-module__text___LfAdf";
export var buyLink = "styles-module__buyLink___oBMzM";